<template lang="pug">
pricing-dialog.mr-5(
  title='Notificaties',
  :header='["Soort", "Kosten per bericht"]'
  :items='[{ name: "SMS", value: "€ 0,13 excl. BTW" }, { name: "Email", value: "Gratis" }]'
  )
</template>

<script>

export default {
  components: {
    PricingDialog: require('@/components/PricingDialog').default
  }
}
</script>
